import { Component, Inject, Prop, Vue } from "vue-property-decorator";

import { JwtHelper } from "iga-vue-ressource/helper";

import template from "./dashboard.vue";

import { IDocument } from "@/models/veos";

import Document from "@/components/document";
import SignatureService from "@/services/signatureService";

import store from "@/store";

/**
 * Dashboard
 */
@Component({
  components: {
    Document,
  },
  mixins: [template],
})
export default class Dashboard extends Vue {

  /**
   * Services de signature électronique
   */
  @Inject() protected signatureService!: () => SignatureService;

  /**
   * Liste des documents
   */
  protected documents: IDocument[] = [];

  /**
   * Erreur survenue chez Docapost
   */
  protected isDocapostError: boolean = false;
  /**
   * Erreur survenue dans VEOS
   */
  protected isVeosError: boolean = false;
  /**
   * Erreur survenue dans VEOS
   */
  protected isSucces: boolean = false;
  /**
   * Affichage du loader en attendant l'affichage de la liste des docuements
   */
  protected isLoader: boolean = true;
  /**
   * Message à afficher suite à la signature du document
   */
  protected signMsg: string = "";

  /**
   * Liste des documents déjà signés
   */
  get docArchive() {
    return this.documents.filter((d) => d.electronicSignatureState === "3" || d.electronicSignatureState === "4");
  }

  /**
   * Liste des documents à signer
   */
  get docEnCours() {
    return this.documents.filter((d) => d.electronicSignatureState === "1" || d.electronicSignatureState === "2");
  }

  /**
   * Initialisation de la vue
   */
  protected mounted() {
    this.isLoader = true;
    if (this.$route.query.result) {

      const auth: string = "auth";
      const token = "" + localStorage.getItem(process.env.VUE_APP_TOKEN);
      store.state[auth].token = token;
      store.state[auth].url = JwtHelper.getTokenValue(token, "url");

      if (this.$route.query.result === "SIGNED") {

        const ids: string[] = ("" + localStorage.getItem(process.env.VUE_APP_PARAM)).split("|");

        this.signatureService().updateSignDocument(ids[0], ids[1]).then(
          () => {
            // redirection vers la liste des documents
            this.isSucces = true;
            this.signMsg = "" + this.$t("signresult.docapost-signed");
            this.listDocs();
          },
          () => {
            this.isVeosError = true;
            this.signMsg = "" + this.$t("signresult.veos-error");
            this.listDocs();
          },
        );
      } else if (this.$route.query.result === "REFUSED") {
        this.isVeosError = true;
        this.signMsg = "" + this.$t("signresult.docapost-refused");
        this.listDocs();
      } else if (this.$route.query.result === "ERROR") {
        this.isDocapostError = true;
        this.signMsg = "" + this.$t("signresult.docapost-error");
        this.listDocs();
      }
    } else {
      this.listDocs();
    }

  }

  /**
   * Appel à VEOS pour récupérer la liste des documents
   */
  private listDocs() {
    this.signatureService().listDocuments().then(
      (data) => {
        this.documents = data.data;
        this.isLoader = false;
      },
      () => {
        this.$router.push("/auth/error");
      },
    );
  }

  /**
   * Affiche une erreur à l'écran
   * @param msg le message d'erreur
   */
  private displayErr(msg: string) {
    this.isVeosError = true;
    this.signMsg = msg;
  }

}
